import { DatePipe, formatDate } from '@angular/common';

import {
  Component,
  DoCheck,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { map } from 'rxjs/internal/operators/map';
import { User } from '../header/header.component';
import { DEFAULT_DATA_PROP_CONFIG, InputType } from 'dg-input-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { KnowledgeManagementService } from '../knowledge-management/service/knowledge-management.service';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DgEmployeeSearchComponent } from 'dg-emp-search-lib';
import { GenericApprovalService } from '../../services/generic-approval.service';
import { AttachmentDialogComponent } from './attachment-dialog/attachment-dialog.component';
import { ActionService } from '../../services/worklist.service';
import { CaseService } from '../../services/case.service';

@Component({
  selector: 'app-generic-info',
  templateUrl: './generic-info.component.html',
  styleUrls: ['./generic-info.component.scss'],
})
export class GenericInfoComponent implements OnInit, DoCheck {
  @ViewChild(DgEmployeeSearchComponent) empSearch: DgEmployeeSearchComponent;
  @ViewChild('returnToTemplate') returnToTemplate: TemplateRef<any>;
  private dialogRef: MatDialogRef<any>;
  refreshCase: BehaviorSubject<boolean> = new BehaviorSubject(false);
  mappingid = null;
  profileAttachTitle: any;
  minStartDate: Date;
  selectedEmployees: string;
  orgConfig = {
    prntId: '70002298',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: false,
    header: 'Reporting Organization',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  empSearchConfig = {
    multiSelect: false,
    header: 'Reporting_Employee',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 char',
  };
  empConfig = {
    multiSelect: true,
    header: 'Select Hierarchy',
    subTitle: 'EmployeeHierarchy',
    selectedSubTitle: 'SelectedHierarchy',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
    btnText: 'submit',
  };
  currentt: string;
  unitId: any;
  unitArray: any;
  address: any;
  selectedIndex: any;
  loginOrgId: any;
  loginOrgName: any;
  loginEmpName: any;
  datatwo: any;
  loginEmpNameTwo: string;
  loginEmpIdTwo: any;
  loginEmpArray: any = [];
  loginEmpIdArray = [];
  loginupdatedArray = [];
  accessRows = [];
  @Input() caseDetails;
  @Input() case;
  @Input() isFromOutboxCases = false;
  @Input() isGenericAprCase = true;
  @Input() readOnly = false;
  @Output() saveData = new EventEmitter();
  previousData: any;
  exisitingJson: any;
  deleteJson = [];
  updateJson = [];
  newJson = [];

  oldJson = [];
  appTempPath: any = null;
  refreshUpload: boolean = true;
  fieldDisabled: boolean;
  isRefresh: boolean = true;
  remarks: any = null;
  loginEmpArrayTwo: any = [];
  loginSaveEmpArray: any = [];
  difference: any = [];
  updatedisable: boolean = true;
  deletedjson: {
    lgSubId: any;
    hrchyLevelPk: any;
    orderNo: any;
    lsbPk: any;
    lvlName: string;
    listUnitMpgVOs: { unitLSBPk: any }[];
  }[];
  accessrowAdding: boolean = true;
  loginEmparrayThree: any = [];
  loginEmpIdOne: any;
  loginEmpIdArrayFinal: any = [];
  newedJson: { newaddednames: any }[];
  oldenJson: { previousnames: any }[];
  approvedFlag: any;
  initiatorFlag: any;
  updateHierarchyFlag: any;
  returnToHierarchyFlag: false;
  returnToUnit: number;
  mpgId: number;
  openEmpDialog(): void {
    this.updatedisable = false;
    setTimeout(() => {
      this.empSearch.openDialog();
    }, 100);
  }
  constructor(
    public translate: TranslateService,
    private kmService: KnowledgeManagementService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private generic: GenericApprovalService,
    private service: ActionService,
    private caseService: CaseService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    const currentDate = new Date();

    this.minStartDate = new Date(currentDate);
  }
  ngDoCheck(): void {}
  current = new Date();
  profileAcceptedType = ['pdf', 'png', 'doc', 'docx', 'xlsx', 'txt', 'xls'];
  profileMaxSize = 200;
  profileUniqueAttachID = 'Data Syncronization';
  isAllowFileToAttachProfile = true;
  profileAttachID = '';
  purposeList = [];
  interfaceList = [];
  finalPath: any;
  expForm: FormGroup;
  processList = [];

  ngOnInit(): void {
    if (this.dialogData?.caseDetails) {
      this.caseDetails = this.dialogData?.caseDetails;
      this.case = this.dialogData?.case;
      this.isGenericAprCase = this.dialogData?.isGenericAprCase;
    }
    this.getAccessGrid();
    // this.populateProcess();
    this.translate.get('Data_sync.Upload').subscribe((res) => {
      this.profileAttachTitle = res;
    });
    this.currentt = formatDate(this.current, 'dd-MM-yyyy', 'en-US');
    this.expForm = new FormGroup({
      background: new FormControl(null, [
        Validators.required,
        Validators.maxLength(2000),
      ]),
      transaction: new FormControl(null, [
        Validators.required,
        Validators.maxLength(2000),
      ]),
      budget: new FormControl(null, [
        Validators.required,
        Validators.maxLength(500),
      ]),
      nature: new FormControl(null, [
        Validators.required,
        Validators.maxLength(500),
      ]),
      subject: new FormControl(null, [
        Validators.required,
        Validators.maxLength(100),
      ]),
      process: new FormControl(null),
      ps: new FormControl(null),
      name: new FormControl(null),
      pran: new FormControl(null),
      currentDate: new FormControl(null),
      time: new FormControl(null),
      reportingEmpId: new FormControl(null),
      reportingEmp: new FormControl(null),
      startDate: new FormControl(null),
      startTime: new FormControl(null),
      purpose: new FormControl(null),
      description: new FormControl(null),
      attachFile: new FormControl(null),
    });
    // this.expForm.controls.district.disable();
    this.expForm.controls.ps.disable();
    this.expForm.controls.name.disable();
    this.expForm.controls.pran.disable();
    this.expForm.controls.currentDate.disable();
    this.expForm.controls.time.disable();
    this.expForm.controls.currentDate.setValue(this.currentt);
    //  this.expForm.controls.district.setValue('Patna');
    this.expForm.controls.ps.setValue('Bhaktiarpur CPI');
    this.expForm.controls.time.setValue(
      formatDate(this.current, 'HH:MM', 'en-US')
    );
    this.checkValidation();

    this.generic.methodForLoginDetails().subscribe((res: User) => {
      const restemp: User = res;
      this.unitId = restemp?.employeeVO?.unitId;
      this.loginEmpIdOne = this.unitId;
      this.unitArray = restemp?.employeeVO?.unitVO;
      this.loginEmpName = restemp?.employeeVO?.empFullName;
      this.loginEmpName = this.loginEmpName.replace(/ +/g, '');
      this.expForm.controls.pran.setValue(restemp.employeeVO.empId);
      this.expForm.controls.name.setValue(restemp.employeeVO.empFullName);
      this.Calculate();
      this.getData();
    });
  }

  getData() {
    this.generic
      .getDocumentData(this.caseDetails.fileId)
      .subscribe((res: any) => {
        this.mpgId = res.apprvlNoteMpgId;
        this.exisitingJson = [];
        this.exisitingJson = res;
        this.approvedFlag = res.approvedFlag;
        this.initiatorFlag = res.initiatorFlag;
        this.updateHierarchyFlag = res.updateHierarchyFlag;
        this.returnToHierarchyFlag = res.returnToHierarchyFlag;
        this.returnToUnit = res.returnToUnit;
        this.previousData = res;
        this.appTempPath = null;
        this.expForm.controls['attachFile'].setValue(null);

        this.expForm.controls.background.setValue(res?.bgDtl);
        this.expForm.controls.nature.setValue(res?.docDtl);
        this.expForm.controls.subject.setValue(res?.subjDtl);
        this.expForm.controls.budget.setValue(res?.expenseDtl);
        this.expForm.controls.transaction.setValue(res?.trnDtl);
        this.expForm.controls.attachFile.setValue(res?.attachId);

        if (
          !(
            this.initiatorFlag &&
            !this.fieldDisabled &&
            !this.approvedFlag &&
            !(this.isFromOutboxCases || this.readOnly)
          )
        ) {
          this.expForm?.controls?.background.disable();
          this.expForm?.controls?.nature.disable();
          this.expForm?.controls?.subject.disable();
          this.expForm?.controls?.budget.disable();
          this.expForm?.controls?.transaction.disable();
          this.expForm?.controls?.attachFile.disable();
        }

        let dataone = res.unitLSBMpgVOs;
        this.loginEmparrayThree = [];
        this.loginEmpIdArray = [];
        this.loginEmpIdArrayFinal = [];
        dataone.forEach((element, i) => {
          this.loginEmpArray[i] = element.listMapForUnit[0].empName.replace(
            / +/g,
            ''
          );
          this.loginEmpIdArray.push(element.listMapForUnit[0].unitId);
          if (i >= 1) {
            this.loginEmpIdArrayFinal.push(element.listMapForUnit[0].unitId);
          }

          this.loginEmparrayThree.push(element.listMapForUnit[0].empName);
        });
        if (this.accessrowAdding) {
          this.accessRows = [];
          for (let i = 0; i < this.loginEmparrayThree.length; i++) {
            let userMessage;
            if (res.hierarchyApprovedFlags[i] === 0) {
              userMessage = this.translate.instant(
                'generic_info.userInitiatedMessage'
              );
            } else if (res.hierarchyApprovedFlags[i] === -1) {
              userMessage = this.translate.instant(
                'generic_info.userClarificationMessage'
              );
            } else if (res.hierarchyApprovedFlags[i] === 1) {
              userMessage = this.translate.instant(
                'generic_info.userAcceptedMessage'
              );
            } else if (res.hierarchyApprovedFlags[i] === -2) {
              userMessage = this.translate.instant(
                'generic_info.userRejectedMessage'
              );
            } else if (res.hierarchyApprovedFlags[i] === 2) {
              userMessage = this.translate.instant(
                'generic_info.userApprovedMessage'
              );
            } else {
              userMessage = this.translate.instant(
                'generic_info.userNAMessage'
              );
            }
            this.accessRows.push({
              levelId: i + 1,
              userName: this.loginEmparrayThree[i],
              isApprover: 'No',
              usermsg: userMessage,
            });
          }
          this.accessRows[this.loginEmpArray.length - 1].isApprover = 'Yes';
        }
        // this.empSearch.selectedEmployeeList = this.loginEmpIdArrayFinal;
        this.empSearch.selectedEmployeeList = this.loginEmpIdArrayFinal;
        // this.getAccessGrid();
        this.loginEmpNameTwo = res.unitLSBMpgVOs[0].listMapForUnit[0].empName;
        this.loginEmpIdTwo = res.unitLSBMpgVOs[0].listMapForUnit[0].unitId;
        this.loginEmpNameTwo = this.loginEmpNameTwo.replace(/ +/g, '');
        this.oldJson = [];
        for (let i = 0; i < this.loginEmpArray.length; i++) {
          this.oldenJson = [
            {
              previousnames: this.loginEmpArray[i],
            },
          ];
          this.oldJson.push(this.oldenJson[0]);
        }
        if (this.loginEmpIdTwo == this.loginEmpIdOne) {
          // if (this.loginEmpNameTwo == this.loginEmpName) {
          this.fieldDisabled = false;
        } else {
          this.fieldDisabled = true;
        }
      });
  }
  onStepChange(data): void {
    this.selectedIndex = data?.selectedIndex;
  }
  onStepClick(i): void {
    this.selectedIndex = i;
  }
  onNextStep(i, type?: number): void {
    this.selectedIndex = i;
  }

  Calculate() {
    this.unitArray.forEach((unit) => {
      if (this.unitId == unit.unitId) {
        this.loginOrgId = unit.deptId;
        unit.organizationVOArr.forEach((org) => {
          this.loginOrgName = org.organizationName;
        });
        return;
      }
    });
  }

  getEmpData(val) {
    this.selectedEmployees = JSON.stringify(val);
    this.expForm.controls['reportingEmp'].setValue(val.POST_ID);
    this.expForm.controls['reportingEmpId'].setValue(val.EMP_ID);
  }
  onChange(e) {}
  onFinalPathForProfile(finalPath: Event): void {
    this.finalPath = finalPath;
    this.expForm.controls.attachFile.setValue(this.finalPath);
  }
  onFinalPath(path) {
    this.appTempPath = path;
  }
  checkValidation() {
    if (this.expForm.valid) return false;
    else return true;
  }
  updateDisable() {
    if (
      (this.previousData?.bgDtl == this.expForm.controls['background'].value &&
        this.previousData?.trnDtl ==
          this.expForm.controls['transaction'].value &&
        this.previousData?.expenseDtl ==
          this.expForm.controls['budget'].value &&
        this.previousData?.docDtl == this.expForm.controls['nature'].value &&
        this.previousData?.subjDtl == this.expForm.controls['subject'].value &&
        !this.appTempPath &&
        !this.remarks) ||
      this.expForm.invalid
    ) {
      return true;
    } else {
      return false;
    }
  }

  populateProcess(processId = null): void {
    this.kmService
      .getComboData('6004', {
        ACTIVE_FLAG: 1,
      })
      .subscribe((processList: any) => {
        this.processList = processList;
        if (processId) {
          this.expForm.controls['process'].setValue(processId);
        }
      });
  }
  accessCols = [];
  pageSize = 5;
  addRowAtTop = false;
  showSearch = false;

  folderId = 1000015328;
  name = '';

  folderId$: Observable<string> = this.route.paramMap.pipe(
    map((params) => params.get('folderId')),
    tap((folderId: string) => {
      this.name = '';
      this.folderId = Number(folderId);

      this.getAccessGrid();
    })
  );

  colPropConfig = DEFAULT_DATA_PROP_CONFIG;

  RQUIRED_VAL_JSON = {
    id: 0,
    async: false,
    type: 'required',
    value: null,
    errorMessage: 'This field is required',
  };

  getAccessGrid(): void {
    this.accessRows = [];
    for (let i = 0; i < this.loginEmpArray.length; i++) {
      this.accessRows[i].levelId = i + 1;
      this.accessRows[i].userName = this.loginEmpArray[i];
      this.accessRows[i].isApprover = 'No';
      if ((i = this.loginEmpArray.length - 1)) {
        this.accessRows[i].isApprover = 'Yes';
      }
      this.accessRows = [...this.accessRows];
    }
    this.accessCols = [
      {
        columnId: 'levelId',
        width: 10,
        displayable: true,
        sortable: false,
        type: 1,
        align: 'left',
        columnName: this.translate.instant('generic_info.level'),
      },
      {
        columnId: 'userName',
        width: 75,
        displayable: true,

        type: null,
        columnName: this.translate.instant('generic_info.empName'),
      },
      {
        columnId: 'isApprover',
        width: 75,
        displayable: true,
        sortable: false,

        type: 3,
        columnName: this.translate.instant('generic_info.finalApprover'),
      },
      {
        columnId: 'usermsg',
        width: 10,
        displayable: true,
        sortable: false,
        type: null,

        searchable: false,
        columnName: this.translate.instant('generic_info.approvingStatus'),

        defaultValue: null,
      },
    ];
  }
  getData2(val): void {
    this.loginSaveEmpArray = [];
    this.empSearch.selectedEmployeeList = [];
    this.updatedisable = false;
    let unitIds = val?.map((employee) => employee?.UNIT_ID);
    this.loginupdatedArray = unitIds;
    let unitNames = val?.map((employee) => employee.FULL_NAME);
    this.loginSaveEmpArray = unitNames;
    unitNames.forEach((element, i) => {
      this.loginEmpArrayTwo.push(element.replace(/ +/g, ''));
    });
    this.empSearch.selectedEmployeeList = unitIds;
    if (this.loginSaveEmpArray.length == 0) {
      this.deleteJson = [];
    } else {
      this.deleteJson = [];
      for (let i = 0; i < this.exisitingJson.unitLSBMpgVOs.length; i++) {
        this.deletedjson = [
          {
            lgSubId: this.exisitingJson.unitLSBMpgVOs[i].lgSubId,

            hrchyLevelPk: this.exisitingJson.unitLSBMpgVOs[i].hrchyLevelPk,

            orderNo: this.exisitingJson.unitLSBMpgVOs[i].orderNo,

            lsbPk: this.exisitingJson.unitLSBMpgVOs[i].lsbPk,

            lvlName: 'null',
            listUnitMpgVOs: [
              {
                unitLSBPk: this.exisitingJson.unitLSBMpgVOs[i].listMapForUnit[0]
                  .unitLSBPk,
              },
            ],
          },
        ];

        this.deleteJson.push(this.deletedjson[0]);
      }
    }
    this.accessRows = [];
    this.accessRows.push({
      levelId: 1,
      userName: this.loginEmparrayThree[0],
      isApprover: 'No',
    });

    for (let i = 0; i < val.length; i++) {
      this.accessRows.push({
        levelId: i + 2,
        userName: val[i].FULL_NAME,
        isApprover: 'No',
      });
    }
    this.accessRows[val.length].isApprover = 'Yes';

    this.accessRows = [...this.accessRows];
  }
  onSave() {
    let deleteJsonOne = [];

    if (this.loginSaveEmpArray.length == 0) {
      this.updateJson = [];
    } else {
      deleteJsonOne = this.deleteJson;
      this.updateJson = [];
      this.updateJson.push({
        isApprover: false,
        unitId: this.loginEmpIdOne,
        listAdminVOs: [
          {
            empName: this.loginEmpName,
            unitId: this.loginEmpIdOne,
          },
        ],
      });
      for (let j = 0; j < this.loginSaveEmpArray.length; j++) {
        this.updateJson.push({
          isApprover: j == this.loginSaveEmpArray.length - 1 ? true : false,
          unitId: this.loginupdatedArray[j],
          listAdminVOs: [
            {
              empName: this.loginSaveEmpArray[j],
              unitId: this.loginupdatedArray[j],
            },
          ],
        });
      }
    }

    this.accessrowAdding = false;
    let postData = {
      bgDtl: this.expForm.controls['background'].value,
      trnDtl: this.expForm.controls['transaction'].value,
      expenseDtl: this.expForm.controls['budget'].value,
      docDtl: this.expForm.controls['nature'].value,
      attachId: this.expForm.controls['attachFile'].value,
      attachmentReference: this.appTempPath,
      caseId: this.caseDetails.fileId,
      subjDtl: this.expForm.controls['subject'].value,
      remarks: null,
      unitLSBMpgVOs: deleteJsonOne,
      adminVOs: this.updateJson,
    };
    this.generic.updateGeneric(postData).subscribe((res: any) => {
      this.getData();
      this.isRefresh = !this.isRefresh;

      this.refreshUpload = false;
      this.appTempPath = null;
      this.expForm.controls['attachFile'].setValue(null);
      if (this.loginSaveEmpArray.length == 0) {
      }
      setTimeout(() => {
        this.remarks = null;
        this.appTempPath = null;
        this.expForm.controls['attachFile'].setValue(null);
        this.refreshUpload = true;
      }, 100);
      this.loginSaveEmpArray = [];
      this.caseService.triggerRefreshParent(this.caseDetails);
    });
  }
  getviewData(): void {
    let postData = {
      bgDtl: this.expForm.controls['background'].value,
      trnDtl: this.expForm.controls['transaction'].value,
      expenseDtl: this.expForm.controls['budget'].value,
      docDtl: this.expForm.controls['nature'].value,
      attachId: this.expForm.controls['attachFile'].value,
      attachmentReference: this.appTempPath,
      caseId: this.caseDetails.fileId,
      subjDtl: this.expForm.controls['subject'].value,
      remarks: null,
      unitId: null,
    };
    this.accessRows?.forEach((row, i) => {
      if (this.unitId == row.unitId) {
        if (row?.remarks) {
          postData.unitId = row.unitId;
          postData.remarks = row.remarks;
        }
      }
    });
    /* this.generic.generateGenericNote(postData).subscribe((res: any) => { */
    const dialogRef = this.dialog.open(AttachmentDialogComponent, {
      data: {
        minWidth: '90vw',
        maxWidth: '90vw',
        height: '75vh',
        minHeight: '75vh',
        tempPath: this.mpgId,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {});
    /*  }); */
  }
  updateActionsatRow(row): any {
    let actionConfig = [];

    if (this.unitId == row.unitId) {
      actionConfig = [
        {
          actionIcon: 'edit',
          isVisible: true,
          isDisabled: false,
          actionName: 'edit',
        },
        {
          actionIcon: 'save',
          isVisible: false,
          isDisabled: false,
          actionName: 'save',
        },
        {
          actionIcon: 'close',
          isVisible: false,
          isDisabled: false,
          actionName: 'close',
        },
      ];
    }
    const cellConfig = {
      headerAlign: 'center',
      columnId: 'actions',
      configAtRowLevel: true,
      width: 10,
      displayable: true,
      sortable: false,
      align: 'center',
      icons: true,
      columnName: 'Actions',
      actionConfig: actionConfig,
    };
    const cell = {
      cellConfig: cellConfig,
    };
    row.actions = cell;
    return row;
  }
  onReturnToHierarchy() {
    this.caseService.triggerSaveParent();
    this.dialogRef = this.dialog.open(this.returnToTemplate, {
      disableClose: true,
    });
  }
  onReturn() {
    let postData = {
      refId: [this.caseDetails.fileId],
      applTypeId: 1,
      toOrderNo: [-1],
      toUnit: [this.returnToUnit],
      roleId: [-1],
      toMpgType: [],
      movmentActionFlag: 3, //change
      fromGrpId: null,
      toGrpId: null,
      fromType: null,
      toType: null,
      toRoleId: null,
      delegationVO: null,
      fromGrpWS: null,
      groupLevel: null,
      groupUnitId: null,
      groupId: null,
      recall: null,
      papsFlag: false,
      line: null,
      subHrhcyLvlPk: null,
    };
    this.generic.returnToHierarchy(postData).subscribe((res: any) => {
      this.dialogRef.close();
      this.service.closeTab.next(this.caseDetails.fileId);
    });
  }
}
